<template>
  <button class="sc-user-input--button-icon-wrapper" :style="{background: chatbotColors.userInput.bg}">
    <icon-base :color="chatbotColors.userInput.text" width="20" height="20">
      <slot />
    </icon-base>
  </button>
</template>

<script>
import IconBase from "./components/IconBase.vue";

export default {
  props: {
    chatbotColors: {
      type: Object,
      required: true
    }
  },
  components:{
    IconBase
  }
}
</script>

<style lang="scss" scoped>
.sc-user-input--button-icon-wrapper {
  flex: 1;
  border: none;
  border-radius: 15px;
  padding: 0px;
  margin: 0px;
  outline: none;
  cursor: pointer;
  transition: opacity 100ms ease-in-out, transform 100ms ease-in-out;

  &:hover {
    opacity: .8;
  }

  &:focus{
    outline: none;
  }

  svg {
    height: 18px;
    width: 18px;
    margin-bottom: -3px;
    margin-right: 3px;
    align-self: center;
    outline: none;
    &:hover path{
      filter: contrast(15%);
    }
  }
}
</style>
